(function ($) {
	'use strict';
	var attributionStorageKey = 'nk_anfragen_attribution_v1';
	var prefillStorageKey = 'nk_anfragen_prefill_email_v1';
	var attributionLifetime = 90 * 24 * 60 * 60 * 1000;
	var attributionKeys = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
		'gclid',
		'fbclid'
	];

	function isValidEmailAddress(email) {
		var input = document.createElement('input');
		input.type = 'email';
		input.required = true;
		input.value = email;
		return input.checkValidity();
	}

	function storePrefillEmail(email) {
		try {
			window.sessionStorage.setItem(prefillStorageKey, email);
		} catch (error) {
			// The URL fragment remains available when storage is blocked.
		}
	}

	function getPrefillEmail() {
		var email = '';
		var hashMatch = window.location.hash.match(/(?:^#|&)email=([^&]*)/);

		if (hashMatch) {
			try {
				email = decodeURIComponent(hashMatch[1].replace(/\+/g, ' '));
			} catch (error) {
				email = '';
			}

			if (window.history && window.history.replaceState) {
				window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
			}
		}

		if (!email) {
			try {
				email = window.sessionStorage.getItem(prefillStorageKey) || '';
			} catch (error) {
				email = '';
			}
		}

		try {
			window.sessionStorage.removeItem(prefillStorageKey);
		} catch (error) {
			// Storage cleanup must never prevent the stepper from loading.
		}

		email = email.trim();
		return isValidEmailAddress(email) ? email : '';
	}

	// The footer email field starts the full inquiry instead of sending a
	// separate partial Contact Form 7 message.
	document.addEventListener('submit', function (event) {
		var form = event.target;
		var wrapper;
		var emailInput;
		var email;
		var targetUrl;

		if (!form || !form.closest) {
			return;
		}

		wrapper = form.closest('.footer-cta-form');
		if (!wrapper) {
			return;
		}

		emailInput = form.querySelector('input[name="your-email"], input[type="email"]');
		email = emailInput ? emailInput.value.trim() : '';
		if (!isValidEmailAddress(email)) {
			return;
		}

		event.preventDefault();
		event.stopImmediatePropagation();
		storePrefillEmail(email);
		targetUrl = wrapper.getAttribute('data-anfragen-url') || '/angebot/';
		window.location.assign(targetUrl.replace(/#.*$/, '') + '#email=' + encodeURIComponent(email));
	}, true);

	function getStoredAttribution() {
		try {
			var stored = window.localStorage.getItem(attributionStorageKey);
			var attribution = stored ? JSON.parse(stored) : null;

			if (!attribution || !attribution.expiresAt || attribution.expiresAt < Date.now()) {
				window.localStorage.removeItem(attributionStorageKey);
				return null;
			}

			return attribution;
		} catch (error) {
			return null;
		}
	}

	function storeAttribution(attribution) {
		try {
			window.localStorage.setItem(attributionStorageKey, JSON.stringify(attribution));
		} catch (error) {
			// Attribution must never prevent the form from working.
		}
	}

	function getQueryParameter(parameterName) {
		var query = window.location.search.substring(1).split('&');
		var value = '';

		$.each(query, function (_, pair) {
			var parts = pair.split('=');
			var key;

			try {
				key = decodeURIComponent((parts.shift() || '').replace(/\+/g, ' '));
			} catch (error) {
				key = '';
			}

			if (key !== parameterName) {
				return;
			}

			try {
				value = decodeURIComponent(parts.join('=').replace(/\+/g, ' '));
			} catch (error) {
				value = '';
			}

			return false;
		});

		return value;
	}

	function getCurrentTouch() {
		var touch = {
			landing_page: window.location.href,
			referrer: document.referrer || '',
			captured_at: new Date().toISOString()
		};
		var hasCampaignData = false;

		$.each(attributionKeys, function (_, key) {
			var value = getQueryParameter(key);
			touch[key] = value.substring(0, 255);
			hasCampaignData = hasCampaignData || value !== '';
		});

		touch.has_campaign_data = hasCampaignData;
		return touch;
	}

	function captureAttribution() {
		var stored = getStoredAttribution();
		var currentTouch = getCurrentTouch();

		if (!stored) {
			stored = {
				first: currentTouch,
				last: currentTouch,
				expiresAt: Date.now() + attributionLifetime
			};
			storeAttribution(stored);
			return stored;
		}

		if (currentTouch.has_campaign_data) {
			stored.last = currentTouch;
			stored.expiresAt = Date.now() + attributionLifetime;
			storeAttribution(stored);
		}

		return stored;
	}

	function populateAttributionFields($form, attribution) {
		if (!attribution) {
			return;
		}

		$.each(['first', 'last'], function (_, touchType) {
			var touch = attribution[touchType] || {};
			var fields = attributionKeys.concat(['landing_page', 'referrer', 'captured_at']);

			$.each(fields, function (__, fieldName) {
				$('<input>', {
					type: 'hidden',
					name: touchType + '_' + fieldName,
					value: touch[fieldName] || ''
				}).appendTo($form);
			});
		});
	}

	$(function () {
		var $flows = $('[data-anfragen-flow]');
		var prefillEmail = $flows.length ? getPrefillEmail() : '';
		var attribution = captureAttribution();
		$flows.each(function () {
			var $flow = $(this);
			var $form = $flow.find('[data-anfragen-form]');
			var $steps = $form.find('[data-step]');
			var $title = $flow.find('[data-current-step-title]');
			var $error = $form.find('[data-form-error]');
			var $next = $form.find('[data-step-next]');
			var $back = $form.find('[data-step-back]');
			var $submit = $form.find('[data-step-submit]');
			var current = 0;
			var busy = false;
			var completed = false;
			var transitionTimer;
			var choices = {};
			var selectedProject = '';
			var arrowSelection = false;
			if (prefillEmail) {
				$form.find('[name="email"]').val(prefillEmail);
			}
			populateAttributionFields($form, attribution);
			if (window.crypto && window.crypto.randomUUID) {
				$form.find('[name="request_id"]').val(window.crypto.randomUUID());
			} else if (window.crypto && window.crypto.getRandomValues) {
				// Also generate a fresh ID on cached pages served over local HTTP.
				var bytes = window.crypto.getRandomValues(new Uint8Array(16));
				bytes[6] = (bytes[6] & 15) | 64;
				bytes[8] = (bytes[8] & 63) | 128;
				var hex = Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
				$form.find('[name="request_id"]').val(hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20));
			}

			function clearError() { $error.text('').prop('hidden', true); }
			function showError(message) { $error.text(message).prop('hidden', false); }
			function focusTitle() {
				$title.get(0).focus({ preventScroll: true });
				var header = document.querySelector('.site-header');
				var top = $title.get(0).getBoundingClientRect().top;
				var offset = header ? header.getBoundingClientRect().bottom + 28 : 28;
				if (top < offset || top > window.innerHeight / 2) {
					window.scrollTo({ top: Math.max(0, window.scrollY + top - offset), behavior: 'auto' });
				}
			}
			function activate(index, focus) {
				if (busy || completed || index < 0 || index >= $steps.length) return;
				window.clearTimeout(transitionTimer);
				current = index;
				$steps.each(function (i) { $(this).prop('hidden', i !== current); });
				$flow.find('[data-step-indicator]').text((current + 1) + ' / ' + $steps.length);
				$title.text($steps.eq(current).attr('data-step-heading'));
				$next.prop('hidden', current === 0 || current === $steps.length - 1);
				$submit.prop('hidden', current !== $steps.length - 1);
				$back.prop('hidden', current === 0);
				$flow.attr('data-current-step', current + 1);
				clearError();
				if (focus) focusTitle();
			}
			function validate(index) {
				var $step = $steps.eq(index);
				var firstInvalid;
				clearError();
				$step.find('[data-field-error]').text('').prop('hidden', true);
				$step.find('[aria-invalid]').removeAttr('aria-invalid');
				$step.find('input:not(:disabled),textarea:not(:disabled)').each(function () {
					this.setCustomValidity('');
					if (this.required && this.type !== 'radio' && this.type !== 'checkbox' && !this.value.trim()) this.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
					if (this.name === 'phone' && (!/^[+0-9().\s\/-]{6,50}$/.test(this.value) || this.value.replace(/\D/g, '').length < 6)) this.setCustomValidity('Bitte geben Sie eine gültige Telefonnummer ein.');
					if (!this.checkValidity()) {
						firstInvalid = firstInvalid || this;
						$(this).attr('aria-invalid', 'true');
						var message = this.name === 'postcode' ? 'Bitte geben Sie eine fünfstellige Postleitzahl ein.' : this.type === 'checkbox' ? 'Bitte bestätigen Sie die Datenschutzerklärung.' : this.validity.typeMismatch ? 'Bitte geben Sie eine gültige E-Mail-Adresse ein.' : this.validationMessage;
						$(this).closest('.anfragen-field').find('[data-field-error]').text(message).prop('hidden', false);
					}
				});
				if (firstInvalid) {
					if (firstInvalid.type === 'radio') showError('Bitte wählen Sie eine Option aus, um fortzufahren.');
					firstInvalid.focus();
					return false;
				}
				return true;
			}
			function selectProject(value) {
				if (selectedProject) choices[selectedProject] = $form.find('[name="project_need"]:checked:not(:disabled)').val();
				selectedProject = value;
				$form.find('[data-project-choices]').each(function () {
					var enabled = $(this).attr('data-project-choices') === value;
					$(this).prop('hidden', !enabled).find('input').prop('disabled', !enabled).prop('checked', false);
					if (enabled && choices[value]) $(this).find('input').filter(function () { return this.value === choices[value]; }).prop('checked', true);
				});
			}
			$form.on('change', '[name="project_type"]', function () { selectProject(this.value); });
			$form.on('keydown keyup', '[name="project_type"]', function (event) {
				if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(event.key) !== -1) {
					arrowSelection = event.type === 'keydown';
				}
				if (event.key === ' ' || event.key === 'Spacebar') {
					event.preventDefault();
					arrowSelection = false;
					if (event.type === 'keydown' && !event.originalEvent.repeat) this.click();
				}
			});
			$form.on('pointerdown', '[name="project_type"]', function () { arrowSelection = false; });
			// Click/Space confirms a card, including a previously selected card after Back.
			// Arrow keys only change selection so native radio keyboard navigation stays usable.
			$form.on('click', '[name="project_type"]', function () {
				if (busy || completed || arrowSelection) return;
				if (selectedProject !== this.value) selectProject(this.value);
				window.clearTimeout(transitionTimer);
				transitionTimer = window.setTimeout(function () { if (current === 0 && validate(0)) activate(1, true); }, 180);
			});
			$form.on('input change', 'input,textarea', function () {
				this.setCustomValidity('');
				$(this).removeAttr('aria-invalid').closest('.anfragen-field').find('[data-field-error]').prop('hidden', true);
				clearError();
			});
			$next.on('click', function () { if (!busy && validate(current)) activate(current + 1, true); });
			$back.on('click', function () { activate(current - 1, true); });
			$form.on('submit', function (event) {
				event.preventDefault();
				if (busy || completed) return;
				if (current < $steps.length - 1) {
					if (validate(current)) activate(current + 1, true);
					return;
				}
				for (var i = 0; i < $steps.length; i++) {
					if (!validate(i)) { activate(i, true); validate(i); return; }
				}
				var data = $form.serializeArray();
				data.push({ name: 'action', value: 'dd_submit_anfragen_form' }, { name: 'nonce', value: $flow.attr('data-nonce') });
				busy = true;
				$form.attr('aria-busy', 'true');
				$submit.prop('disabled', true).text('Wird gesendet …');
				$back.prop('disabled', true);
				$.ajax({ url: $flow.attr('data-ajax-url'), type: 'POST', data: data, timeout: 45000 })
					.done(function (response) {
						if (!response || !response.success) { showError(response && response.data ? response.data.message : 'Beim Senden ist ein Fehler aufgetreten.'); return; }
						completed = true;
						$steps.prop('hidden', true);
						$flow.find('.anfragen-flow-header, [data-form-navigation]').prop('hidden', true);
						$form.find('[data-success-state]').prop('hidden', false).find('[tabindex]').get(0).focus();
					})
					.fail(function (xhr) {
						var response = xhr.responseJSON;
						var field = response && response.data && response.data.field;
						busy = false;
						if (field) {
							var $input = $form.find('[name]').filter(function () { return this.name === field && !this.disabled; }).first();
							var index = $steps.index($input.closest('[data-step]'));
							if (index >= 0) { activate(index, true); $input.attr('aria-invalid', 'true').trigger('focus'); }
						}
						showError(response && response.data ? response.data.message : 'Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.');
					})
					.always(function () { busy = false; $form.removeAttr('aria-busy'); $submit.prop('disabled', false).text('Projektanfrage senden'); $back.prop('disabled', false); });
			});
			$form.prop('hidden', false);
			activate(0, false);
		});
	});
})(jQuery);
